import React from "react";
import styled from "@emotion/styled";
import { useStores } from "@stores";
import { observer } from "mobx-react-lite";
import { ASSETS_TYPE } from "@src/constants";
import Text from "@components/Text";
import SizedBox from "@components/SizedBox";
import useWindowSize from "@src/hooks/useWindowSize";
import RomeDesktopTable from "./RomeDesktopTable";
import RomeMobileAssetsTable from "./RomeMobileAssetsTable";

interface IProps {}

const Root = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 40px;
`;

const RomeAssetsTable: React.FC<IProps> = () => {
  const { width } = useWindowSize();
  const { lendStore } = useStores();

  if (
    width &&
    width < 880 &&
    lendStore.mobileDashboardAssets !== ASSETS_TYPE.HOME
  )
    return null;

  //todo add filter
  return (
    <Root>
      <Text weight={500} size="big" fitContent>
        All Assets
      </Text>
      <SizedBox height={8} />
      {/*filter*/}
      {width && width >= 880 ? <RomeDesktopTable /> : <RomeMobileAssetsTable />}
    </Root>
  );
};
export default observer(RomeAssetsTable);
